import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Input,
  Button,
  Modal,
  Row,
  Col,
  Select,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { DownOutlined } from "@ant-design/icons";
import _ from "lodash";
import useLocalStorageService from "../../services/localStorage"
const { Option } = Select;

const { TextArea } = Input;

const AddPaymentModal: FC<{ onClose: () => void; eventObj?: any, socket?: ISocket, id?: any, mode?:any, message?:any }> = (props) => {
  const { onClose, eventObj, socket, id, mode, message } = props;
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);


  const [event, setEvent] = useState<any>({
    title: "",
    description: "",
    currency: "$",
    amount: undefined
  });

  const updateEvent = (key: keyof any, value: ValueOf<any>) => {
    setEvent((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const dispatch = useDispatch();
  const handleOk = () => {
    const data = {...event};
    let edit = undefined;
    if (mode === "edit" && message) {
      edit = { id: message.id, originalCreatedAt: message.originalCreatedAt, originalPageMessageId: message.originalPageMessageId };
    }
    console.log("mode", mode, data, edit);
    dispatch({
      type: "SEND_MESSAGE",
      payload: { message: event.title, type: "pay", data, edit },
    });
    setIsModalVisible(false);
    onClose && onClose();
  };


  useEffect(() => {
    if (eventObj) {
      const tempEvent = {...eventObj}
      setEvent(tempEvent);
    }
  }, []);


  return (
    <Modal
      title={eventObj ? `Edit pay` : "Add pay"}
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Row>
        <Col span={24}>
          <Input
            value={event.title}
            onChange={(e) => updateEvent("title", e.target.value)}
            placeholder="Payment Title"
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col span={24}>
          <TextArea
              autoSize={{ minRows: 4, maxRows: 6 }}
              placeholder="Payment Description"
              value={event.description}
              onChange={(e)=>{updateEvent('description', e.target.value)}}
            />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col span={24}>
        <Input
            type="number"
            value={event.amount}
            onChange={(e) => updateEvent("amount", e.target.value)}
            placeholder="Payment amount"
          />
        </Col>
      </Row>
      
      
      <Row className="mt-3">
        <Col span={24}>
          <Select
            value={event.currency}
            className="w-full"
            placeholder="Currency"
            onChange={(values) => {
              updateEvent("currency", values);
            }}
            options={[
              { label: "$", value: "$" },
              { label: "£", value: "£" },
              { label: "€", value: "€" },
            ]}
          />
        </Col>
      </Row>
      
        <Row className="action-grp mt-5">
          <Col span={14} className="pr-2">
            <Button
              className="beam-btn green-btn cover w-full"
              onClick={handleOk}
            >
              {"Save"}
            </Button>
          </Col>
          <Col span={10} className="pl-2">
            <Button
              className="beam-btn orange-btn bordered w-full"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Col>
        </Row>
  
    </Modal>
  );
};

export default AddPaymentModal;
